import { Product } from '../../constants/AppConstants';
import { ISidebarMenu } from '../../hooks/SidebarMenuHook';
import investmentFinanceSidebarMenu from './investmentFinanceSidebarConfig';
import settlementFinanceSidebarMenu from './settlementFinanceSidebarConfig';

export interface SidebarConfigType {
  [key: string]: ((roles: string[]) => ISidebarMenu) | undefined,
}

const SidebarConfig: SidebarConfigType = {
  [Product.SETTLEMENT_FINANCE]: settlementFinanceSidebarMenu,
  [Product.INVESTMENT_FINANCE]: investmentFinanceSidebarMenu,
};

export default SidebarConfig;
